// Terms of Use acceptance as reported by the superuser user list
// (`legal_accepted`: true accepted the current versions, false pending,
// null for accounts that are never asked, i.e. market owners and admins).
export const LEGAL_FILTERS = [
  { value: 'all', label: 'All Terms' },
  { value: 'accepted', label: 'Terms accepted' },
  { value: 'pending', label: 'Terms pending' },
];

export function matchesLegalFilter(user, filter) {
  if (filter === 'accepted') return user?.legal_accepted === true;
  if (filter === 'pending') return user?.legal_accepted === false;
  return true;
}
